import Vue from 'vue';
import Vuex from 'vuex';

import teamDataModule from './modules/teamData';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        teamData: teamDataModule,
    }
})